(function () {
  function init() {
    var tabsWrap = document.getElementById('BootsSaleTabs');
    var tabs = document.querySelectorAll('[data-boots-tab]');
    if (!tabsWrap || !tabs.length) return;

    var sectionId = tabsWrap.dataset.sectionId;
    var rootUrl = tabsWrap.dataset.rootUrl || '/';

    function applyActiveStyle(tab, isActive) {
      var isSale = tab.classList.contains('boots-sale-tabs__tab--sale');
      var count = tab.querySelector('.boots-sale-tabs__count');
      if (!isSale) {
        if (isActive) {
          tab.style.setProperty('border-color', '#263c96', 'important');
          if (count) {
            count.style.setProperty('background-color', '#263c96', 'important');
            count.style.setProperty('color', '#fff', 'important');
          }
        } else {
          tab.style.removeProperty('border-color');
          if (count) {
            count.style.removeProperty('background-color');
            count.style.removeProperty('color');
          }
        }
        return;
      }
      if (isActive) {
        tab.style.setProperty('background-color', '#f50b0b', 'important');
        tab.style.setProperty('border-color', '#f50b0b', 'important');
        tab.style.setProperty('color', '#fff', 'important');
        if (count) {
          count.style.setProperty('background-color', '#fff', 'important');
          count.style.setProperty('color', '#c40909', 'important');
        }
      } else {
        tab.style.removeProperty('background-color');
        tab.style.removeProperty('border-color');
        tab.style.removeProperty('color');
        if (count) {
          count.style.removeProperty('background-color');
          count.style.removeProperty('color');
        }
      }
    }

    function setActiveTab(clickedTab) {
      tabs.forEach(function (tab) {
        var isActive = tab === clickedTab;
        tab.classList.toggle('boots-tab-active', isActive);
        applyActiveStyle(tab, isActive);
      });
    }

    function swapGrid(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newContainer = parsed.getElementById('ProductGridContainer');
      var container = document.getElementById('ProductGridContainer');
      if (newContainer && container) {
        container.innerHTML = newContainer.innerHTML;
      }
      if (typeof FacetsToggle === 'function') {
        new FacetsToggle();
      }
    }

    // Refreshes both tabs for a given ground-type tag (or the base totals when
    // tagHandle is falsy): fetches each collection's tag-filtered page and syncs
    // that tab's href (so the next click preserves the tag) and badge count from
    // its own accurately-scoped response.
    function refreshCounts(tagHandle) {
      if (!sectionId) return;
      var suffix = tagHandle ? '/' + tagHandle : '';
      tabsWrap.dataset.currentTag = tagHandle || '';
      ['soccer-boots', 'soccer-boots-sale'].forEach(function (handle) {
        var url = rootUrl + 'collections/' + handle + suffix;
        fetch(url + '?section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var newTab = parsed.querySelector('.boots-sale-tabs__tab.boots-tab-active');
            var liveTab = tabsWrap.querySelector('[data-collection-handle="' + handle + '"]');
            if (!newTab || !liveTab) return;
            liveTab.setAttribute('href', newTab.getAttribute('href'));
            var newCount = newTab.querySelector('.boots-sale-tabs__count');
            var liveCount = liveTab.querySelector('.boots-sale-tabs__count');
            if (newCount && liveCount) liveCount.textContent = newCount.textContent;
          })
          .catch(function () {});
      });
    }

    function tagHandleFromUrl(url) {
      var m = url.match(/^\/collections\/(?:soccer-boots-sale|soccer-boots)(?:\/([^/?]+))?/);
      return m ? m[1] || null : null;
    }

    function loadTab(tab, updateHistory) {
      var url = tab.getAttribute('href');
      var container = document.getElementById('ProductGridContainer');
      if (container) container.classList.add('boots-sale-loading');

      fetch(url + '?section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          swapGrid(html);
          setActiveTab(tab);
          if (tab.dataset.title) document.title = tab.dataset.title;
          if (updateHistory) {
            history.pushState({ bootsSaleTab: url }, '', url);
          }
          var top = tabsWrap.getBoundingClientRect().top + document.documentElement.scrollTop - 100;
          window.scrollTo({ top: top, left: 0, behavior: 'smooth' });
          refreshCounts(tagHandleFromUrl(url));
        })
        .catch(function () {
          window.location.href = url;
        })
        .finally(function () {
          if (container) container.classList.remove('boots-sale-loading');
        });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        if (tab.classList.contains('boots-tab-active')) return;
        e.preventDefault();
        loadTab(tab, true);
      });
    });

    window.addEventListener('popstate', function () {
      var match = null;
      tabs.forEach(function (tab) {
        if (tab.getAttribute('href') === window.location.pathname) match = tab;
      });
      if (match && !match.classList.contains('boots-tab-active')) loadTab(match, false);
    });

    document.addEventListener('boots:tagchange', function (e) {
      refreshCounts(e.detail && e.detail.tagHandle);
    });

    // Correct the non-active tab's count if the page was loaded directly on a
    // tag-filtered URL (e.g. a bookmark or shared link), since its server-rendered
    // value is the unfiltered collection total until this runs.
    if (tabsWrap.dataset.currentTag) {
      refreshCounts(tabsWrap.dataset.currentTag);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
